import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { useRequest } from '../../../hooks/UseRequest';
import { setNotification } from '../../../redux/notificationSlice';
import Loading from '../../../components/Loading';
import RefiEligibilityFailureCard from '../../../components/refi/RefiEligibilityFailureCard';

export default function CashOutRefinanceEligibilityModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const [loading, setLoading] = useState(true);
  const [eligibilityResult, setEligibilityResult] = useState(null);
  const request = useRequest();
  const loanId = modal.options?.loanId;

  useEffect(() => {
    if (modal.is_active && modal.type === 'cash_out_refinance_eligibility_modal' && loanId) {
      checkEligibility();
    }
  }, [modal.is_active, modal.type, loanId]);

  const checkEligibility = async () => {
    setLoading(true);
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/loan/${loanId}/refi_eligibility_check`);
    try {
      const response = await request.get();
      if (response.status === 200 || response.status === 201) {
        setEligibilityResult(response?.data?.data);
      } else {
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message ?? 'Failed to check eligibility';
      dispatch(setNotification({ type: 'error', body: errorMessage }));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEligibilityResult(null);
    setLoading(true);
    dispatch(setModal({ is_active: false }));
  };

  const renderEligibilityResult = () => {
    if (eligibilityResult?.is_eligible) {
      return (
        <div className="notification is-success is-light">
          <h3 className="title is-size-5 mb-1">
            Initial Check Passed
          </h3>
          <p className="is-size-6">
            This customer passed the initial check, please transfer to Reacts to determine full eligibility.
          </p>
        </div>
      );
    } else {
      return (
        <RefiEligibilityFailureCard
          reason={eligibilityResult?.reason}
          body="This customer is not eligible for a cash out refi. To get additional principal, they would need to pay off their existing loan and apply for a new one."
        />
      );
    }
  };

  return modal.is_active && modal.type === 'cash_out_refinance_eligibility_modal' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card modal-card-confirmation column is-5">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            Cash Out Refi Eligibility Check
          </p>
          <button className="delete" aria-label="close" onClick={handleClose}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ minHeight: "100px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column">
              {loading ? (
                <div className="has-text-centered py-4">
                  <Loading />
                  <p className="mt-2">Checking eligibility...</p>
                </div>
              ) : (
                renderEligibilityResult()
              )}
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1 pr-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button
              type="button"
              className="button is-small has-background-grey has-text-white"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
